/**
 * 买家站内信 API（对接真实后端 /api/buyer/message/**）
 */
import { get, put } from '@/api/request';

/** 站内信 VO（对齐后端 BuyerMessage） */
export interface BuyerMessageVO {
  id: string;
  buyerId?: string;
  /** 消息类型：后端实际取值含 INQUIRY_SUBMITTED/INQUIRY_REPLY/QUOTE_ACCEPTED/ORDER_CREATED 等，放宽为 string 由前端按类型映射 */
  msgType?: string;
  title?: string;
  content?: string;
  relatedInquiryId?: string;
  isRead?: number;
  createdAt?: string;
}

export const messageApi = {
  /** 消息列表（按时间倒序） */
  list: (buyerId: string) => get<BuyerMessageVO[]>(`/buyer/message?buyerId=${encodeURIComponent(buyerId)}`),
  /** 标记已读 */
  markRead: (id: string) => put<void>(`/buyer/message/${id}/read`),
};
